<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "app"
};
</script>
<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
#app {
  background: $s-cp-neutral-800;
  position: relative;
  @include setStyles("15", $s-typography-sizes);

  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

html,
body {
  height: 100%;
}

.v-select {
  .vs__open-indicator {
    fill: $s-cp-neutral-400;
  }
  &.vs--open {
    .vs__dropdown-toggle {
      outline: $s-cp-sup-focus auto 1px;
    }
    .vs__open-indicator {
      transform: rotate(0) scale(1);
      fill: $s-cp-neutral-400;
    }
    .vs__selected {
      opacity: 1;
    }
  }
}
</style>
